<template>
    <Head title="Auditor Login" />

    <jet-authentication-card>
        <div class="flex flex-col text-center w-full mb-4">
            <LogoAppSquare class="h-24 w-24 m-auto" />
            <h2 class="text-xl font-semibold mt-4 text-gray-700">Auditor Login Portal</h2>
        </div>

        <jet-validation-errors class="mb-4" />

        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
            {{ status }}
        </div>

        <form @submit.prevent="submit">
            <div>
                <jet-label for="username" value="Username" />
                <jet-input
                    id="username"
                    type="text"
                    class="mt-1 block w-full"
                    v-model="form.username"
                    required
                    autofocus
                    placeholder="auditor_XXX"
                />
            </div>

            <div class="mt-4">
                <jet-label for="password" value="Password" />
                <jet-input
                    id="password"
                    type="password"
                    class="mt-1 block w-full"
                    v-model="form.password"
                    required
                    autocomplete="current-password"
                />
            </div>

            <div class="flex items-center justify-between mt-4">
                <label class="flex items-center">
                    <jet-checkbox
                        name="remember"
                        v-model:checked="form.remember"
                    />
                    <span class="ml-2 text-sm text-gray-600">Remember me</span>
                </label>
            </div>
            <div class="mt-4" >
                <div class="sample-captcha">
                    <section class="data-box">
                        <jet-input
                            v-model="inputValue"
                            placeholder="Enter captcha code"
                            class="input"
                            type="text"
                        />
                    </section>

                    <section class="captcha-box">
                        <VueClientRecaptcha
                            :value="inputValue"
                            @getCode="getCaptchaCode"
                            @isValid="checkValidCaptcha"
                        />
                    </section>
                </div>

            </div>
            <div class="py-4">
                <div class="border-t border-gray-200"></div>
            </div>

            <div class="flex items-center justify-end">
                <InertiaButtonLogin
                    class="mr-1"
                    :class="{ 'opacity-25': form.processing }"
                    label="Login"
                />
                <ButtonReset></ButtonReset>
            </div>
            <div class="text-center mt-4">
                <Link
                    :href="route('index')"
                    class="
                        underline
                        text-sm text-blue-700
                        hover:text-[#4338CA]
                        font-semibold
                    "
                >
                    Homepage
                </Link>
            </div>
        </form>
    </jet-authentication-card>
</template>

<script>
import { defineComponent } from "vue";
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard";
import LogoAppSquare from "@/Logo/LogoAppSquare";
import InertiaButtonLogin from "@/Components/InertiaButtonLogin.vue";
import ButtonReset from "@/Components/ButtonReset.vue";
import JetInput from "@/Jetstream/Input";
import JetCheckbox from "@/Jetstream/Checkbox";
import JetLabel from "@/Jetstream/Label";
import JetValidationErrors from "@/Jetstream/ValidationErrors";
import { Head, Link } from "@inertiajs/inertia-vue3";
import { ref, reactive } from "@vue/reactivity";
import VueClientRecaptcha from "vue-client-recaptcha";

export default defineComponent({
    components: {
        Head,
        JetAuthenticationCard,
        LogoAppSquare,
        InertiaButtonLogin,
        ButtonReset,
        JetInput,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
        Link,
        VueClientRecaptcha,
    },

    props: {
        canResetPassword: Boolean,
        canRegister: Boolean,
        status: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                username: "",
                password: "",
                remember: false,
            }),

        };
    },

    methods: {
        submit() {
            console.log('Submitting to:', this.route("login_auditor.submit"));
            console.log('Form data:', this.form);
            
            // Skip captcha check for debugging
            this.form
                .transform((data) => ({
                    ...data,
                    remember: this.form.remember ? "on" : "",
                }))
                .post(this.route("login_auditor.submit"), {
                    onFinish: () => {
                        console.log('Form finished');
                        this.form.reset("password");
                    },
                    onError: (errors) => {
                        console.log('Form errors:', errors);
                    },
                    onSuccess: () => {
                        console.log('Form success');
                    },
                });
        },
    },
    setup() {
        /* pass value to captcha  */
        const inputValue = ref(null);

        const data = reactive({
            captchaCode: null,
            isValid: false,
        });
        const getCaptchaCode = (value) => {
            /* you can access captcha code */
            data.captchaCode = value;
        };
        const checkValidCaptcha = (value) => {
            /* expected return boolean if your value and captcha code are same return True otherwise return False */
            data.isValid = value;
            if (value) {

            }
        };
        return {
            inputValue,
            data,
            getCaptchaCode,
            checkValidCaptcha,
        };
    },
});
</script>
